import React from 'react';
import config from 'config';
import {DocumentList} from 'components/documents';
import {changeStatus, changeType} from './accosts-list';

export const AccostDetailList = ({ accost }) => (
  <DocumentList>
    <li>Реєстраційний номер: <strong>{accost.get('id')}</strong></li>
    {accost.get('staff_data') &&
    <li>Лікар: <strong>{accost.get('staff_data').get('user_data').get('last_name')} {accost.get('staff_data').get('user_data').get('first_name')} {accost.get('staff_data').get('user_data').get('middle_name')}</strong></li>
    }
    <li>Лікарня: <strong>{accost.get('institution_data').get('full_title')}</strong></li>
    <li>Тип: <strong>{changeType(accost.get('type'))}</strong></li>
    <li>Дата створення: <strong>{new Date(accost.get('date_created')).toLocaleString('uk-UA', config.options)}</strong></li>
    <li>Короткий опис: <strong>{accost.get('brief_description')}</strong></li>
    <li>Детальний опис: <strong style={{whiteSpace: "pre-wrap"}}>{accost.get('detail_description')}</strong></li>
    <li>Стан: <strong>{changeStatus(accost.get('status'))}</strong></li>
  </DocumentList>
);



// WEBPACK FOOTER //
// ./src/cabinet/reviews/accost-detail-list.js